export default "__VITE_ASSET__f0162da0__"